import React, { FC } from 'react';
import clsx from 'clsx';
import { omit } from 'lodash';

import Button from '../../Button';
import HelperText from '../HelperText';
import Icons from '../../SvgLib/icons';
import styles from './selectField.module.sass';

export interface SelectFieldProps {
  valueKey: string;
  options: SelectFieldOption[];
  emptyOption?: string;
  emptyOptionProps?: Omit<React.OptionHTMLAttributes<HTMLOptionElement>, 'value'>;
  optionProps?: Omit<React.OptionHTMLAttributes<HTMLOptionElement>, 'value'>;
  helperText?: string;
  error?: string;
  rootClassName?: string;
  otherProps?: Omit<React.SelectHTMLAttributes<HTMLSelectElement>, 'name'>;
  variant?: 'outlined' | 'standard';
  loading?: boolean;
  loadingMessage?: string;
}

export interface SelectFieldOption {
  id: string | number;
  value: string | number;
  name: string | number;
}

const SelectField: FC<SelectFieldProps> = props => {
  const {
    valueKey,
    options,
    emptyOption,
    optionProps,
    emptyOptionProps,
    helperText,
    error,
    rootClassName,
    otherProps,
    variant = 'outlined',
    loading = false,
    loadingMessage = '',
  } = props;
  // if (!options.length) return null;
  return (
    <div className={clsx(styles.selectFieldRoot, rootClassName)}>
      {loading ? (
        <div className="is-flex">
          <div
            className={clsx(styles.selectField, otherProps?.className, {
              [styles.standardSelectField]: variant === 'standard',
            })}
          >
            {loadingMessage}
          </div>
          <Button
            isLoader
            classes="is-loading"
            style={{
              marginLeft: '-30px',
            }}
          />
        </div>
      ) : (
        <>
          <select
            name={valueKey}
            className={clsx(styles.selectField, otherProps?.className, {
              [styles.selectFieldError]: !!error,
              [styles.standardSelectField]: variant === 'standard',
            })}
            {...omit(otherProps, 'className')}
          >
            {emptyOption && (
              <option value="" {...emptyOptionProps}>
                {emptyOption}
              </option>
            )}
            {options.map(o => (
              <option key={o.id} value={o.value} {...optionProps}>
                {o.name}
              </option>
            ))}
          </select>
          {/* <div className={styles.arrow}>{Icons({})["arrow-down"]}</div> */}
          {Icons({})['arrow-down']}
        </>
      )}
      {(error || helperText) && <HelperText error={!!error}>{error ?? helperText}</HelperText>}
    </div>
  );
};

export default SelectField;
